import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { authService } from "@/services/auth";
import { UtilsService } from "@/services/utils/utils.service";
import type { UpdateProfileDto } from "@/services/auth";

const utils = new UtilsService();

export interface CompleteProfileDto {
  userId: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export const useCompleteProfile = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CompleteProfileDto) => {
      const profileData: UpdateProfileDto = {
        userId: data.userId,
        firstName: data.firstName,
        lastName: data.lastName,
        phone: data.phone,
      };
      return authService.updateProfile(profileData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["onboardingStatus"] });
      queryClient.invalidateQueries({ queryKey: ["userProfile"] });
      toast.success(t("onboarding.profileCompleted"));
    },
    onError: (error: unknown) => {
      const errorMessage = utils.extractErrorMessage(
        error,
        t("onboarding.profileCompletionFailed")
      );
      toast.error(errorMessage);
    },
  });
};

